import { sessionTitleFromText } from "@orni/sdk-typescript";

export const SESSION_MESSAGE_MAX_BYTES = 128 * 1024;
export const WORK_OBJECTIVE_MAX_BYTES = 32 * 1024;

const encoder = new TextEncoder();

export function utf8ByteLength(value: string): number {
  return encoder.encode(value).byteLength;
}

export function exceedsUtf8Limit(value: string, maxBytes: number): boolean {
  return utf8ByteLength(value) > maxBytes;
}

export function formatInputLimit(maxBytes: number): string {
  return `${Math.floor(maxBytes / 1024)} KB`;
}

export function sessionTitleFromPrompt(value: string): string {
  return sessionTitleFromText(value);
}
